export enum InvitationType {
    InviteUsersViaEmail = 'Invite a single user via email',
    InviteUsersViaCSV = 'Upload a .csv of emails',
    AddVirtualAgent = 'Add a virtual agent user',
}
